import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
// console.log({ timezone: dayjs.tz.guess() });
// dayjs.tz.setDefault(dayjs.tz.guess());
export default dayjs;
